var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10c.006 5.52 4.48 9.994 10 10zm5.376-10.677a.834.834 0 0 1 1.655-.2A7.148 7.148 0 0 1 17.014 11a.833.833 0 0 1-1.651-.234 5.465 5.465 0 0 0 .013-1.445v.002zm.024 3.933a.833.833 0 0 1 .13 1.167 7.11 7.11 0 0 1-1.363 1.302.833.833 0 0 1-.982-1.347c.39-.284.74-.618 1.042-.995a.833.833 0 0 1 1.173-.129v.002zm-4.723 3.794a7.32 7.32 0 0 1-.666.032H10c-.311 0-.622-.02-.93-.06a.833.833 0 1 1 .212-1.653c.25.031.479.037.73.046.173 0 .343-.008.51-.024a.833.833 0 1 1 .157 1.659h-.002zM8.207 3.782a.833.833 0 0 1 .26 1.646A4.537 4.537 0 0 0 4.583 10a5.407 5.407 0 0 0 1.95 4.162.833.833 0 0 1-1.068 1.28A7.07 7.07 0 0 1 2.917 10a6.177 6.177 0 0 1 5.29-6.218z",
    fill: "#161038",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCircle);
export default __webpack_public_path__ + "static/media/loading-circle.49d89a9e394052ad2abd6619e180ddbd.svg";
export { ForwardRef as ReactComponent };